import { TConfig, TConfigInput } from '@@/auto/interfaces';
import { excludeFalse } from '@@/auto/utils/excludeFalse';

function ToyotaSCConfig(): DeepPartial<TConfigInput> {
  return {
    auto: (auto: TConfig['auto']) => ({
      ...auto,
      addOns: {
        ...auto.addOns,
        getAddOns: () =>
          excludeFalse([
            'towing_road_services',
            'loss_of_use',
            'ridesharing',
            'oem_parts',
            'new_car_replacement',
          ] as const),
      },
    }),
  };
}
export default ToyotaSCConfig;
